import PrimaryButton from "@/components/common/PrimaryButton";
import Image from "next/image";
import { useState } from "react";

const CustomSoftwareAccordion = ({ data }) => {
  const [activeIndex, setActiveIndex] = useState(null);
  const onItemClick = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };
  return (
    <div className="bg-primary-black px-4 py-12 md:p-0">
      <div className="w-full md:py-16 md:px-8 lg:px-10">
        {data.map((value, index) => (
          <div key={index} className='border border-x-0 border-t-0 border-white/60'>
              <div className="mb-0 my-4">
                <div
                  className="text-left py-4 pr-4 cursor-pointer"
                  onClick={(event) => {
                    setTimeout(() => {
                      event.target.scrollIntoView(true);
                    }, 300),
                      onItemClick(index);
                  }}
                >
                  <h2
                    className={`text-primary-black font-poppins text-medium text-3xl md:text-5xl xl:text-7xl xl:leading-normal customSoftwareTitle hover:bg-full webkit-text-stroke-white bg-clip-text bg-gradient-custom-accordion ${
                      index === activeIndex ? "bg-full" : ""
                    }`}
                  >
                    <span className="font-poppins">{value.heading}</span>
                  </h2>
                </div>
                <div
                  className={`text-base pb-4 ${
                    index === activeIndex
                      ? "block border border-solid border-b-0 border-x-0 border-gray-100/50"
                      : "hidden"
                  }`}
                >
                  <div className="flex flex-col-reverse md:flex-row">
                    <div className="py-12 w-full md:w-3/4">
                      <p className="text-lg md:text-xl font-normal text-white [&>a]:text-[#00b1f0] mb-4">
                        <span
                          dangerouslySetInnerHTML={{ __html: value.details }}
                        ></span>
                      </p>
                      <ul className="p-0">
                        {value.list.map((listvalue, index) => (
                          <li
                            key={listvalue}
                            className="list-none text-xl font-normal text-white"
                          >
                            <span>
                              <span className="text-primary-yellow mr-2">
                                0{index + 1}
                              </span>
                              {listvalue}
                            </span>
                          </li>
                        ))}
                      </ul>
                      <div className="pt-12">
                        <PrimaryButton
                          arrow={false}
                          link={value.link}
                          val={value.value}
                        />
                      </div>
                    </div>
                    <div>
                      <Image
                        alt={value.alt}
                        height={860}
                        src={value.image}
                        title={value.title}
                        width={960}
                      />
                    </div>
                  </div>
                </div>
              </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CustomSoftwareAccordion;
